if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"planApp","remotes":[],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return /^(408|474|792|922|96)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}